import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  Select,
  SelectItem,
  Tabs,
  Tab,
} from '@nextui-org/react';
import { Species } from 'common/src/utils/types';
import { getAllSpecies } from 'common/src/api/species';
import { toast } from 'react-toastify';
import MarketRetail from 'common/src/sections/home/MarketRetail';
import RetailSkusTable from './RetailSkusTable';
import SpeciesConfigTab from './SpeciesConfigTab';
import { LoadingState, PageHeader, PageLayout } from '../../../components/ui';

const RetailSkusPage: React.FC = () => {
  const [species, setSpecies] = useState<Species[]>([]);
  const [selectedSpeciesId, setSelectedSpeciesId] = useState<number | null>(
    null
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const all = await getAllSpecies();
        setSpecies(all);
        // Default to kiwi (id=8) if exists, else first species
        const kiwi = all.find((s) => s.id === 8);
        setSelectedSpeciesId(kiwi?.id ?? all[0]?.id ?? null);
      } catch (e: any) {
        toast.error(`Error cargando especies: ${e.message}`);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <PageLayout className='flex flex-col gap-4'>
      <PageHeader
        title='SKUs Retail'
        description='URLs específicas de PDPs (Product Detail Pages) que se scrapean periódicamente. El trackeo por SKU fijo garantiza serie de tiempo comparable: cada ciclo se mide exactamente el mismo producto.'
        actions={
          !loading &&
          species.length > 0 && (
            <Select
              size='sm'
              label='Especie'
              className='w-full md:w-[260px]'
              selectedKeys={
                selectedSpeciesId != null
                  ? new Set([String(selectedSpeciesId)])
                  : new Set([])
              }
              onSelectionChange={(keys) => {
                const k = Array.from(keys)[0];
                if (k != null) setSelectedSpeciesId(Number(k));
              }}
            >
              {species.map((s) => (
                <SelectItem key={String(s.id)} value={String(s.id)}>
                  {s.name}
                </SelectItem>
              ))}
            </Select>
          )
        }
      />

      {loading ? (
        <Card>
          <CardBody>
            <LoadingState label='Cargando...' />
          </CardBody>
        </Card>
      ) : selectedSpeciesId != null ? (
        <Tabs aria-label='Vistas Retail' variant='underlined' size='lg'>
          <Tab key='skus' title='SKUs trackeados'>
            <Card>
              <CardBody>
                <RetailSkusTable speciesId={selectedSpeciesId} />
              </CardBody>
            </Card>
          </Tab>
          <Tab key='chart' title='Gráfico de precios'>
            <MarketRetail forceSpeciesId={selectedSpeciesId} />
          </Tab>
          <Tab key='config' title='Grupos'>
            <SpeciesConfigTab speciesId={selectedSpeciesId} />
          </Tab>
        </Tabs>
      ) : (
        <Card>
          <CardBody>
            <p className='text-default-500'>No hay especies disponibles.</p>
          </CardBody>
        </Card>
      )}
    </PageLayout>
  );
};

export default RetailSkusPage;
